import React, { useState } from 'react';
import { API_URL } from '../assets/globalConstants';
import fallbackLogo from '../img/bringfood-inline-logo.png';
import { logoCandidates } from '../utils/tenantBranding';

export default function TenantLogo({ branding, preferSquare = false, className = '', squareClassName = '', ...props }) {
  const [failed, setFailed] = useState([]);
  const candidates = logoCandidates(branding, preferSquare);
  const signature = candidates.map(logo => logo.id).join('|');
  const logo = candidates.find(candidate => !failed.includes(`${signature}:${candidate.id}`));
  // Undefined means settings have not arrived. Keep space without showing another brand.
  if (!branding) return <span className={className} style={{ display: 'inline-block', width: 64 }} aria-hidden="true" />;
  return <img
    {...props}
    className={`${className}${logo?.square ? ` ${squareClassName}` : ''}`}
    src={logo ? `${API_URL}/images/${encodeURIComponent(logo.id)}` : fallbackLogo}
    alt={logo ? `${branding.companyName || 'Store'} Logo` : 'BringFood Logo'}
    onError={logo ? () => setFailed(previous => [...previous, `${signature}:${logo.id}`]) : undefined}
  />;
}
